interface DragHandleIconProps {
  className?: string
  size?: number
}

/**
 * A 6-dot grip pattern icon (2 columns x 3 rows) used as a drag handle.
 * Based on the Figma design for the charges table.
 */
const DragHandleIcon = ({ className, size = 24 }: DragHandleIconProps) => (
  <svg
    className={className}
    fill="currentColor"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Left column - 3 dots */}
    <circle cx="9" cy="6" r="2" />
    <circle cx="9" cy="12" r="2" />
    <circle cx="9" cy="18" r="2" />
    {/* Right column - 3 dots */}
    <circle cx="15" cy="6" r="2" />
    <circle cx="15" cy="12" r="2" />
    <circle cx="15" cy="18" r="2" />
  </svg>
)

export default DragHandleIcon
